import React from "react";
import ProductList from "../Components/ProductList";

const hotelFacilities = [
  { name: "Menu", path: "/menu", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg" },
  { name: "Room Service", path: "/room-service", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg" },
  { name: "Salon", path: "/salon", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg" },
];

function HotelFacilities() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Hotel Facilities</h1>
      <ProductList products={hotelFacilities} isCategory />
    </div>
  );
}

export default HotelFacilities;